import React, { useEffect, useRef } from 'react';
import type TalkJS from 'talkjs';
import { SendMessageEvent } from 'talkjs/all';
import analytics from '../../../modules/analytics';

type TalkjsChatboxProps = {
  chatSession: TalkJS.Session;
  currentConversation: TalkJS.ConversationBuilder;
  canMount: boolean;
  isUserPro: boolean;
};

export const TalkjsChatbox: React.FC<TalkjsChatboxProps> = ({
  chatSession,
  currentConversation,
  canMount,
  isUserPro,
}) => {
  const chatbox = useRef<TalkJS.Chatbox>(null);
  const chatMountingElement = useRef();

  const chatboxStyle = {
    display: 'flex',
    flexBasis: isUserPro ? '100%' : 'calc(100% - 4px)',
  };

  useEffect(() => {
    if (canMount) {
      chatbox.current = chatSession.createChatbox(currentConversation);
      chatbox.current.select(currentConversation);
      chatbox.current.mount(chatMountingElement.current);
      chatbox.current.onSendMessage((event: SendMessageEvent) => {
        if (event.me.role === 'provider') {
          analytics.track('chat_message_sent', {
            provider_id: event.me.id,
            conversation_id: event.conversation.id,
            role: 'provider',
            message_text: event.message.text,
          });
        }
        if (event.me.role === 'client') {
          analytics.track('chat_message_sent', {
            client_user_id: event.me.id,
            conversation_id: event.conversation.id,
            role: 'client',
            message_text: event.message.text,
          });
        }
      });
    }
    return () => {
      chatbox.current?.destroy();
    };
  }, [canMount]);
  return (
    <div ref={chatMountingElement} style={chatboxStyle} />
  );
};
